import { styled } from "@mui/material/styles";
import AirplaneIconSvg from "assets/images/icons/airplane.svg";
import BubbleIconSvg from "assets/images/icons/bubble-annotation.svg";
import SearchIconSvg from "assets/images/icons/search-page.svg";
import IconTitleSvg from "assets/images/icons/check-badge.svg";

export const SummaryExp = styled("div", {
  label: "summary",
})`
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  gap: ${({ theme }) => theme.spacing(3)};

  ${({ theme }) => theme.breakpoints.up("sm")} {
    width: 80%;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: left;
    width: 50%;
    height: 80%;
    justify-content: center;
  }
`;

export const TopExp = styled("div", { label: "top" })`
  display: flex;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.breakpoints.up("sm")} {
    max-height: 100%;
  }

  ${({ theme }) => theme.breakpoints.up("md")} {
    align-items: flex-start;
    height: 100%;
    width: 45%;
    padding-bottom: 0;
  }
`;

export const TitleExp = styled("h1", {
  label: "title",
})`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.color.gray[10]};
  text-align: center;
  line-height: 1.1;

  ${({ theme }) => theme.breakpoints.up("md")} {
    text-align: left;
    font-size: 46px;
    margin-bottom: ${({ theme }) => theme.spacing(2)};
    margin: 0;
  }
`;

export const ArtContainer = styled("div", {
  label: "art-container",
})`
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  ${({ theme }) => theme.breakpoints.up("md")} {
    background: ${({ theme }) => theme.palette.color.secondary[95]};
    height: 80%;
    flex: initial;
  }
`;

export const AirplaneIcon = styled(AirplaneIconSvg, {
  label: "airplane-icon",
})`
  fill: ${({ theme }) => theme.palette.color.gray[30]};
  width: ${({ theme }) => theme.spacing(2.5)};
  height: ${({ theme }) => theme.spacing(2.5)};
`;

export const ChatIcon = styled(BubbleIconSvg, {
  label: "chat-icon",
})`
  fill: ${({ theme }) => theme.palette.color.gray[30]};
  width: ${({ theme }) => theme.spacing(2.5)};
  height: ${({ theme }) => theme.spacing(2.5)};
`;

export const SearchIcon = styled(SearchIconSvg, {
  label: "search-icon",
})`
  fill: ${({ theme }) => theme.palette.color.gray[30]};
  width: ${({ theme }) => theme.spacing(2.5)};
  height: ${({ theme }) => theme.spacing(2.5)};
`;

export const LeadExp = styled("div", {
  label: "lead",
})`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const ApprovalContainer = styled("div", {
  label: "approval-container",
})`
  display: flex;
  background-color: ${({ theme }) => theme.palette.color.success.background};
  color: ${({ theme }) => theme.palette.color.success.color};
  width: fit-content;
  padding: ${({ theme }) => theme.spacing(1, 2)};
  border-radius: ${({ theme }) => theme.shape.borderRadius * 2}px;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  line-height: 1.2;
  margin-bottom: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.breakpoints.up("tablet")} {
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;

export const TitleIcon = styled(IconTitleSvg, { label: "title-icon" })`
  fill: currentColor;
  width: 1.25rem;
  height: 1.25rem;
`;

export const ApprovalText = styled("p", {
  label: "approval-text",
})`
  font-size: 1rem;
  font-weight: 500;
`;

export const TextContainer = styled("div", {
  label: "text-container",
})`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const Item = styled("span", {
  label: "item",
})`
  font-weight: 500;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.color.gray[30]};

  ${({ theme }) => theme.breakpoints.up("sm")} {
    font-size: 18px;
  }
`;

export const Container = styled("div", {
  label: "container",
})`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up("md")} {
    align-items: initial;
  }
`;
